import {PerspectiveCamera, Vector2, Vector3, WebGLRenderer, Clock} from 'three'

class Common {
  $wrapper: HTMLElement | null
  screenSize: Vector2 = new Vector2()
  screenSize_old: Vector2 = new Vector2()
  isMobile: boolean = false
  delay: {
    bg: number
    middle: number
    main: number
  }
  wrapperOffset: Vector2 = new Vector2()

  pixelRatio: number = 1
  aspect: number = 1

  center: Vector3 = new Vector3(0, 0, 0)
  cameraZ: number = 0.9
  camera: PerspectiveCamera = new PerspectiveCamera(80, this.aspect, 0.1, 50)
  camera2: PerspectiveCamera = new PerspectiveCamera(80, this.aspect, 0.1, 50)

  fbo_screenSize: Vector2 = new Vector2()

  renderer?: WebGLRenderer
  $canvas?: HTMLCanvasElement

  clock?: Clock

  time: number = 0
  delta: number = 0
  constructor() {
    this.$wrapper = null

    this.delay = {
      bg: 600,
      middle: 200,
      main: 600,
    }

    this.camera.position.set(0, 0, this.cameraZ)
    this.camera2.position.set(0, 0, this.cameraZ)

    this.fbo_screenSize = new Vector2()
  }

  init($wrapper: HTMLElement, $canvas: HTMLCanvasElement) {
    this.pixelRatio = Math.min(1.5, window.devicePixelRatio)

    this.renderer = new WebGLRenderer({
      alpha: true,
      canvas: $canvas,
    })

    this.$canvas = $canvas

    this.$wrapper = $wrapper
    this.$wrapper.appendChild(this.$canvas)
    this.renderer.setPixelRatio(this.pixelRatio)

    this.clock = new Clock()
    this.clock.start()
    this.resize()
  }

  resize() {
    if (!this.$wrapper) return
    const wrapperRect = this.$wrapper.getBoundingClientRect()
    this.wrapperOffset.set(wrapperRect.left, wrapperRect.top)

    const width = wrapperRect.width
    const height = wrapperRect.height

    this.screenSize_old.copy(this.screenSize)
    this.screenSize.set(width, height)

    this.fbo_screenSize.set(width * this.pixelRatio, height * this.pixelRatio)

    this.aspect = width / height

    this.camera.aspect = this.camera2.aspect = this.aspect

    if (window.innerWidth <= 543) {
      this.cameraZ = 0.7
    } else {
      this.cameraZ = 0.9
    }

    this.camera.updateProjectionMatrix()
    this.camera2.updateProjectionMatrix()

    this.renderer?.setSize(this.screenSize.x, this.screenSize.y)
  }

  getEase(scale = 1) {
    return Math.min(1.0, scale * this.delta)
  }

  update() {
    const delta = this.clock?.getDelta()
    this.delta = delta || 0
    this.time += this.delta
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Common()
